module.exports = __webpack_public_path__ + "static/media/Shikha Chopra.e3c2fbfb.png";